define('responsive-game-feed/app/scripts/utils/logger',['require','exports','module','app-console/app-console'],function(require,exports,module){
    var Logg = require( "app-console/app-console" );
    return new Logg({
        ns : "game-feed"
    });
});
